module.exports = __webpack_public_path__ + "static/img/10.5cd1aa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/About/Honor/images/10.png
// module id = 6aye
// module chunks = 1